import { Injectable } from '@angular/core';

/**
 * Frontend log gyűjtő szolgáltatás
 * Excel feltöltési folyamat során összegyűjti a frontend logokat
 */
@Injectable({
  providedIn: 'root'
})
export class FrontendLogService {
  private logs: string[] = [];

  /**
   * Log üzenet hozzáadása
   */
  addLog(message: string): void {
    const timestamp = new Date().toISOString().split('T')[1].substring(0, 12);
    const formattedMessage = `[${timestamp}] ${message}`;
    this.logs.push(formattedMessage);
    // console.log(message); // Továbbra is kiírjuk a console-ra is
  }

  /**
   * Összes log lekérése
   */
  getLogs(): string[] {
    return [...this.logs];
  }

  /**
   * Logok törlése
   */
  clearLogs(): void {
    this.logs = [];
  }

  /**
   * Logok számának lekérése
   */
  getLogCount(): number {
    return this.logs.length;
  }
}
